













import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/app/common/component/FormHeader.vue';
import ResetPasswordForm from '@/app/auth/resetPassword/ResetPasswordForm.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';
import NotificationService from '@/app/common/service/NotificationService';
import AuthService from '@/app/common/service/AuthService';
import IResetPassword from '@/app/auth/resetPassword/IResetPassword';

@Component({
  name: 'ResetPasswordContainer',
  components: { FormHeader, ResetPasswordForm, HeaderImg },
})
export default class ResetPasswordContainer extends Vue {
  get logoUrl(): string {
    return this.$store.getters.logoUrl;
  }

  public async onResetPassword(api: IResetPassword) {
    try {
      await AuthService.resetPassword(api, this.$route.params.token);
      NotificationService.success('Hasło zostalo zmienione');
      await this.$router.push({name: 'Login'});
    } catch (e) {
      NotificationService.error(e);
    }
  }
}
